import { useEffect } from 'react'
import type { ComponentType } from 'react'
import { matchRoute } from './routes'
import { MeshColorPicker } from './components/MeshColorPicker'
import { ClientOnly } from './components/ClientOnly'
import { CookieBanner } from './components/CookieBanner'

/**
 * Router shell. The page component is resolved by the entry point (server or
 * client) before render, so each per-route bundle only loads its own page
 * chunk. The client entry intercepts same-origin links and swaps this Page
 * prop for SPA navigation without putting a Suspense fallback in the shell.
 */
export default function App({ Page, url }: { Page: ComponentType; url?: string }) {
  const pathname =
    url ?? (typeof window !== 'undefined' ? window.location.pathname : '/')
  const route = matchRoute(pathname)

  useEffect(() => {
    if (route.seo.title) document.title = route.seo.title
  }, [route.seo.title])

  return (
    <>
      <Page />
      <MeshColorPicker />
      {/* Reads localStorage, so it must stay out of the prerender. */}
      <ClientOnly>
        <CookieBanner />
      </ClientOnly>
    </>
  )
}
